import {fabric} from "fabric";
import DieCut, {setDieCut} from "./masks/dieCut/dieCut";

export default class MaskService {
    store;
    imageEditor;

    oldMask;
    mask;

    constructor(store, imageEditor) {
        this.store = store;
        this.imageEditor = imageEditor;
    }

    updateMask () {
        let app = this;

        if (this.oldMask !== app.store.maskData[this.store.mask_type].type && this.mask) {
            if (this.mask.onDetach) {
                this.mask.onDetach();
            }

            this.mask = null;
        }

        switch (app.store.maskData[this.store.mask_type].type) {
            case 'square':
                let square = new fabric.Rect({
                    fill: 'white',
                    width: 300,
                    height: 300,
                });

                app.setMask(square);
                break;
            case 'circle':
                let circle = new fabric.Circle({
                    radius: 150,
                    fill: 'white',
                });

                app.setMask(circle);

                break;
            case 'rounded_corners':
                let rect = new fabric.Rect({
                    fill: 'white',
                    width: 300,
                    height: 300,
                    rx: app.store.maskData.rounded_corners.radius, // set the x-radius of the corners (horizontal)
                    ry: app.store.maskData.rounded_corners.radius  // set the y-radius of the corners (vertical)
                });

                app.setMask(rect);
                break;
            case 'die_cut_small':
                setDieCut({maskService: this, param: app.store.maskData.die_cut_small})
                break;
            case 'die_cut_medium':
                setDieCut({maskService: this, param: app.store.maskData.die_cut_medium})
                break;
            case 'die_cut_custom':
                setDieCut({maskService: this, param: app.store.maskData.die_cut_custom})
                break;
        }

        this.oldMask = app.store.maskData[this.store.mask_type].type;
    }

    setMask (img, options = { setScale: true}) {
        this.store.setLoading('processing.setMask', '');

        let store = this.store;
        let canvas = store.canvas;

        img.set({
            isMask: true,
            absolutePositioned: true,
            selectable: true,
            hoverCursor: 'default',
            fill: 'blue',
            originX: 'center',
            originY: 'center',
            left: 0,
            top: 0,
        });

        if (options.setScale) {
            let width = Number.parseFloat(store.width);
            let height = Number.parseFloat(store.height);
            img.set({
                scaleX: width,
                scaleY: height,
            });
        }

        // canvas.centerObject(img);

        if (store.mask) {
            canvas.remove(store.mask);
        }
        store.mask = img;

        canvas.set({clipPath: img});

        canvas.requestRenderAll();
        store.setLoadingFinished('processing.setMask');
    }
}
